import type { FormEvent } from 'react';
import { useState } from 'react';
import type { DominantEmotion, PlanAdherence } from 'shared';

import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import type { ReviewContextDto } from '../../lib/api/endpoints';
import { useSubmitReview } from '../reviews/useSubmitReview';

import { ReviewHeader } from './ReviewHeader';
import { EmotionSelect, LessonInput, PlanAdherenceSelect } from './ReviewInputs';

export function QuickReviewCard({
  context,
  tradeId,
}: {
  context: ReviewContextDto;
  tradeId: string;
}) {
  const submitReview = useSubmitReview(context.lifecycle.accountId);
  const [planAdherence, setPlanAdherence] = useState<PlanAdherence | ''>('');
  const [dominantEmotion, setDominantEmotion] = useState<DominantEmotion | ''>('');
  const [oneLineLesson, setOneLineLesson] = useState('');

  function submit(event: FormEvent) {
    event.preventDefault();
    if (!planAdherence || !dominantEmotion) return;
    submitReview.mutate({
      tradeId,
      body: {
        mode: 'quick',
        planAdherence,
        dominantEmotion,
        ...(oneLineLesson.trim() ? { oneLineLesson: oneLineLesson.trim() } : {}),
      },
    });
  }

  return (
    <Card>
      <form className="space-y-5" onSubmit={submit}>
        <ReviewHeader context={context} />
        <PlanAdherenceSelect value={planAdherence} onChange={setPlanAdherence} />
        <EmotionSelect value={dominantEmotion} onChange={setDominantEmotion} />
        <LessonInput value={oneLineLesson} onChange={setOneLineLesson} />
        {submitReview.isError ? (
          <p className="text-sm text-danger">Review could not be submitted.</p>
        ) : null}
        {submitReview.isSuccess ? (
          <p className="text-sm text-success">Review submitted. Trade-plan gate cleared.</p>
        ) : null}
        <Button
          type="submit"
          className="min-h-11 w-full sm:w-auto"
          disabled={!planAdherence || !dominantEmotion || submitReview.isPending}
        >
          Submit review
        </Button>
      </form>
    </Card>
  );
}
